import React, { useContext, useEffect } from 'react';
import Style from './Active.module.scss';
import { useFetchConsignmentList } from '../../Hooks/useFetchConsignmentList';
import { ETabValue } from 'Pages/UserDashboard/Consignment/Consignment.d';
import TabToolbar from '../TabToolbar';
import { useTabToolbarForm } from '../../Hooks/useTabToolbarForm';
import { ConsignmentRootDataContext } from 'Pages/UserDashboard/Consignment/Contexts/ConsignmentRootData';
import TabContent from '../TabContent/TabContent';

interface IActiveProps {
  // TODO: need to fill interface based on requirement
}

const Active: React.FC<IActiveProps> = (props) => {
  const consignmentContext = useContext(ConsignmentRootDataContext);
  const status = ETabValue.Active;

  const { form: formTabToolbar } = useTabToolbarForm({});

  const { isFetching, data, parentData, refresh } = useFetchConsignmentList({
    status,
    pause: consignmentContext.value.isFirstRenderTabToolbar,
    params: formTabToolbar.values,
    setParams: formTabToolbar.setValues,
  });

  const dataSource = data as Array<any>;

  useEffect(() => {
    if(isFetching){
      consignmentContext.value.setIsFetchingSummary(true);
      consignmentContext.value.dispatch();
      return;
    }

    if (parentData) {
      const summary = parentData as any;
      consignmentContext.value.setIsFetchingSummary(false);
      consignmentContext.value.setSummaryData({
        revenue: summary?.total_transaction ?? 0,
        totalConsignedItems: summary?.total_consigned_items ?? 0,
      });
      consignmentContext.value.dispatch();
    }
  }, [isFetching, parentData]);

  useEffect(() => {
    consignmentContext.value.setFormTabToolbar(formTabToolbar);

    return () => {
      consignmentContext.value.setFormTabToolbar(null);
    };
  }, []);

  return (
    <div className={Style['active']}>
      <TabToolbar paginationData={parentData} />
      <TabContent
        dataSource={dataSource}
        isFetching={isFetching}
        refresh={refresh}
        type={status}
      />
    </div>
  );
};

export default Active;
